export default __webpack_public_path__ + "static/media/black-line-measure-icon.7d993888.svg";